export enum INQUIRY {
  'FOUNDER_CONSULT' = 'FOUNDER_CONSULT',
  'SYSTEM' = 'SYSTEM',
}

export const CONST_INQUIRY = Object.values(INQUIRY);
